import React, { PureComponent } from "react";
import history from '@scandipwa/scandipwa/src/util/History';
import RangeSlider from 'Component/RangeSlider/RangeSlider.component';
import { generateQuery, getQueryParam, removeQueryParamWithoutHistory } from '@scandipwa/scandipwa/src/util/Url';
import { GQLCurrencyEnum } from "@scandipwa/scandipwa/src/type/Graphql.type";
import { getCurrencySymbol } from "simple-currency-format";

export class PriceFilter extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            priceminvalue: 100,
            pricemaxvalue: 32500,
            priceFilterminvalue: 0,
            priceFiltermaxvalue: 32500,
            pricechangevalue: false
        }

        this.cahngePriceminValue.bind(this);
    }

    componentDidMount() {
        const location = window?.location;

        // price filter
        const queryfilter = getQueryParam("customFilters", location || '');

        if (queryfilter) {
            let priceIndex = queryfilter.indexOf('price:');

            let resultString = priceIndex !== -1 ? queryfilter.substring(priceIndex).split(';')[0].replace("price:", "").split("_") : queryfilter;

            if (priceIndex !== -1) {
                this.setState({
                    priceminvalue: resultString[0],
                    pricemaxvalue: resultString[1],
                    priceFilterminvalue: resultString[0],
                    priceFiltermaxvalue: resultString[1],
                });
            } else {
                this.setState({
                    priceminvalue: 100,
                    pricemaxvalue: 32500,
                    priceFilterminvalue: 100,
                    priceFiltermaxvalue: 32500,
                });
            }
        }
    }

    cahngefilterpriceminvalue = (e) => {
        if (isNaN(e.target.value)) {
            const currencySymbol = getCurrencySymbol(GQLCurrencyEnum.USD);
            if (e.target.value.includes(currencySymbol)) {
                const pricevalue = e.target.value.replace(currencySymbol, "");

                this.setState({
                    priceminvalue: pricevalue.replaceAll(",", ""),
                    pricechangevalue: true
                });
            }
        } else {
            this.setState({
                priceminvalue: e.target.value,
                pricechangevalue: true
            });
        }
    }

    cahngefilterpricemaxvalue = (e) => {
        if (isNaN(e.target.value)) {
            const currencySymbol = getCurrencySymbol(GQLCurrencyEnum.USD);
            if (e.target.value.includes(currencySymbol)) {
                const pricevalue = e.target.value.replace(currencySymbol, "");

                this.setState({
                    pricemaxvalue: pricevalue.replaceAll(",", ""),
                    pricechangevalue: true
                });
            }
        } else {
            this.setState({
                pricemaxvalue: e.target.value,
                pricechangevalue: true
            });
        }
    }

    cahngePriceminValue = (e) => {
        const { pricemaxvalue, priceminvalue } = this.state;
        const location = window?.location;
        const queryfilter = getQueryParam("customFilters", location || '');
        let query = "";

        if (e.code === "Enter" || e.keyCode === 13) {
            if (priceminvalue > 32500) {
                this.setState({
                    priceminvalue: 32500,
                    priceFilterminvalue: 32500
                });
                query = `32500_${pricemaxvalue}`;
            } else if (priceminvalue < 100) {
                this.setState({
                    priceminvalue: 100,
                    priceFilterminvalue: 100
                });
                query = `100_${pricemaxvalue}`;
            } else if (pricemaxvalue < priceminvalue) {
                this.setState({
                    priceminvalue: pricemaxvalue,
                    priceFilterminvalue: pricemaxvalue
                });
                query = `${pricemaxvalue}_${pricemaxvalue}`;
            } else {
                if (isNaN(priceminvalue)) {
                    this.setState({
                        priceminvalue: 100,
                        priceFilterminvalue: 100
                    });
                    query = `100_${pricemaxvalue}`;
                } else {
                    this.setState({
                        priceminvalue: priceminvalue,
                        priceFilterminvalue: priceminvalue
                    });
                    query = `${priceminvalue}_${pricemaxvalue}`;
                }
            }

            this.setState({
                pricechangevalue: false
            });

            const pagefilter = getQueryParam("page", location || '');
            if (pagefilter) {
                removeQueryParamWithoutHistory('page', history, window.location);
            }

            if (queryfilter) {
                let priceIndex = queryfilter.indexOf('price:');
                let resultString = priceIndex !== -1 ? queryfilter.substring(priceIndex).split(';') : queryfilter;

                if (priceIndex !== -1) {
                    if (priceminvalue <= 100 && pricemaxvalue >= 32500) {
                        query = generateQuery({ customFilters: queryfilter.replace(`${resultString[0]}`, ``) }, window.location, history);
                    } else {
                        query = generateQuery({ customFilters: `price:${queryfilter.replace(resultString[0], query)}` }, window.location, history);
                    }
                } else {
                    query = generateQuery({ customFilters: queryfilter.concat(`;price:${query}`) }, window.location, history);
                }
            } else {
                query = generateQuery({ customFilters: `price:${query}` }, window.location, history);
            }

            if (!query) {
                history.push(location?.pathname);
            } else {
                history.push(query);
            }
        }
    }

    cahngePricemaxValue = (e) => {
        const { priceminvalue, pricemaxvalue } = this.state;
        const location = window?.location;
        const queryfilter = getQueryParam("customFilters", location || '');
        let query = "";

        if (e.code === "Enter" || e.keyCode === 13) {
            if (pricemaxvalue > 32500) {
                this.setState({
                    pricemaxvalue: 32500,
                    priceFiltermaxvalue: 32500
                })
                query = `${priceminvalue}_32500`;
            } else if (pricemaxvalue < 100) {
                this.setState({
                    pricemaxvalue: 100,
                    priceFiltermaxvalue: 100
                })
                query = `${priceminvalue}_100`;
            } else if (pricemaxvalue < priceminvalue) {
                this.setState({
                    pricemaxvalue: priceminvalue,
                    priceFiltermaxvalue: priceminvalue
                });
                query = `${priceminvalue}_${priceminvalue}`;
            } else {
                if (isNaN(pricemaxvalue)) {
                    this.setState({
                        pricemaxvalue: 32500,
                        priceFiltermaxvalue: 32500
                    });
                    query = `${priceminvalue}_32500`;
                } else {
                    this.setState({
                        pricemaxvalue: pricemaxvalue,
                        priceFiltermaxvalue: pricemaxvalue
                    });
                    query = `${priceminvalue}_${pricemaxvalue}`;
                }
            }

            this.setState({
                pricechangevalue: false
            });

            const pagefilter = getQueryParam("page", location || '');
            if (pagefilter) {
                removeQueryParamWithoutHistory('page', history, window.location);
            }

            if (queryfilter) {
                let priceIndex = queryfilter.indexOf('price:');
                let resultString = priceIndex !== -1 ? queryfilter.substring(priceIndex).split(';') : queryfilter;

                if (priceIndex !== -1) {
                    if (priceminvalue <= 100 && pricemaxvalue >= 32500) {
                        query = generateQuery({ customFilters: queryfilter.replace(`${resultString[0]}`, ``) }, window.location, history);
                    } else {
                        query = generateQuery({ customFilters: `price:${queryfilter.replace(resultString[0], query)}` }, window.location, history);
                    }
                } else {
                    query = generateQuery({ customFilters: queryfilter.concat(`;price:${query}`) }, window.location, history);
                }
            } else {
                query = generateQuery({ customFilters: `price:${query}` }, window.location, history);
            }

            if (!query) {
                history.push(location?.pathname);
            } else {
                history.push(query);
            }
        }
    }

    onPriceinput = (e) => {
        if (this.state.pricechangevalue === false) {
            this.setState({
                pricemaxvalue: e.maxValue,
                priceminvalue: e.minValue,
                priceFiltermaxvalue: e.maxValue,
                priceFilterminvalue: e.minValue
            });
        }
    }

    handleChangeOptions = (e) => {
        const location = window?.location;
        const queryfilter = getQueryParam("customFilters", location || '');
        let query = "";

        if (this.state.pricechangevalue === false) {
            this.setState({
                pricemaxvalue: e.maxValue,
                priceminvalue: e.minValue,
                priceFiltermaxvalue: e.maxValue,
                priceFilterminvalue: e.minValue
            });
        }

        const pagefilter = getQueryParam("page", location || '');
        if (pagefilter) {
            removeQueryParamWithoutHistory('page', history, window.location);
        }

        if (queryfilter) {
            let priceIndex = queryfilter.indexOf('price:');
            let resultString = priceIndex !== -1 ? queryfilter.substring(priceIndex).split(';') : queryfilter;

            if (priceIndex !== -1) {
                if (e.minValue <= 100 && e.maxValue >= 32500) {
                    query = generateQuery({ customFilters: queryfilter.replace(`${resultString[0]}`, ``) }, window.location, history);
                } else {
                    query = generateQuery({ customFilters: queryfilter.replace(resultString[0], `price:${e.minValue}_${e.maxValue}`) }, window.location, history);
                }
            } else {
                query = generateQuery({ customFilters: queryfilter.concat(`;price:${e.minValue}_${e.maxValue}`) }, window.location, history);
            }
        } else {
            query = generateQuery({ customFilters: `price:${e.minValue}_${e.maxValue}` }, window.location, history);
        }
        if (!query) {
            history.push(location?.pathname);
        } else {
            history.push(query);
        }
    }

    renderPrice() {
        const { pricemaxvalue, priceminvalue } = this.state;
        const currencySymbol = GQLCurrencyEnum.USD;

        const pricewithcurrency = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currencySymbol,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(pricemaxvalue);

        const priceminwithcurrency = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currencySymbol,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(priceminvalue);

        return (
            <>
                <RangeSlider
                    label={false}
                    min={100}
                    max={32500}
                    step={1}
                    minValue={this.state.priceFilterminvalue}
                    maxValue={this.state.priceFiltermaxvalue}
                    className={"caratrangeslider"}
                    oninput={(e) => this.onPriceinput(e)}
                    onChange={(e) => this.handleChangeOptions(e)}
                />
                <div className='carat-input-value'>
                    <div>
                        <input
                            className='caratvalue'
                            type='text'
                            value={priceminwithcurrency}
                            onChange={this.cahngefilterpriceminvalue}
                            onKeyDown={this.cahngePriceminValue}
                            name='minvalue'
                        />
                        {/* <span className="currency-code">$</span> */}
                    </div>
                    <div>
                        <input
                            className='caratvalue caratvalue-right'
                            type='text'
                            value={pricewithcurrency}
                            onChange={this.cahngefilterpricemaxvalue}
                            onKeyDown={this.cahngePricemaxValue}
                            name='maxvalue'
                        />
                        {/* <span className="currency-code currency-code-right">$</span> */}
                    </div>
                </div>
            </>
        )
    }

    render() {
        return (
            <>
                {this.renderPrice()}
            </>
        );
    }
}

export default PriceFilter;